<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title">Province Detail</h3>
      </div>

      <div class="card-body">
        <div class="row">

          <!-- Country Dropdown -->
          <div class="col-md-6">
            <label>Country</label>
            <select v-model="form.C_CODE" class="form-control">
              <option value="">Select Country</option>
              <option v-for="c in countries" :key="c.ID" :value="c.ID">
                {{ c.Title }}
              </option>
            </select>
          </div>

          <!-- Province Name -->
          <div class="col-md-6">
            <label>Province Name</label>
            <input type="text" v-model="form.PVN_NAME" class="form-control" />
          </div>

          <!-- Active -->
          <div class="col-md-6 mt-3">
            <label>Active</label><br>
            <input type="checkbox" v-model="form.PVN_ISACTIVE" true-value="Y" false-value="N" />
          </div>

        </div>

        <!-- Buttons -->
        <div class="mt-4">
          <a class="btn btn-primary" href="../UIC/ProvinceList">Back to List</a>
          <button class="btn btn-success float-right mr-1" @click="save">Save</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      id: 0,
      countries: [],
      form: {
        PVN_ID: 0,
        PVN_NAME: "",
        PVN_ISACTIVE: "Y",
        C_CODE: ""
      }
    };
  },

  created() {
    const params = new URLSearchParams(window.location.search);
    this.id = parseInt(params.get("id"));

    this.loadCountries();

    if (this.id) {
      this.loadData();
    }
  },

  methods: {

    loadCountries() {
      axios.get("/api/UICApi/getCountries")
        .then(res => {
          this.countries = res.data;
        });
    },

    loadData() {
      axios.get(`/api/UICApi/getProvinceById?id=${this.id}`)
        .then(res => {
          if (res.data.status) {
            this.form = res.data.data;
          } else {
            toastr.error(res.data.msg);
          }
        });
    },

    save() {
      axios.post("/api/UICApi/saveProvince", this.form)
        .then(res => {
          if (res.data.status) {
            toastr.success("Saved Successfully");
            this.back();
          } else {
            toastr.error(res.data.msg);
          }
        });
    },

    back() {
      window.location.href = "/UIC/ProvinceList";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ims/Province.vue